import { faCcMastercard, faCcVisa } from '@fortawesome/free-brands-svg-icons';
import { faLifeRing } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import cx from 'classnames';
import {
    CAREER,
    CAREER_URL,
    COMMERCIAL,
    COMMERCIAL_URL,
    COOKIE_POLICY_PAGE,
    DATA_PRIVACY,
    FOLLOW_US_ON_FACEBOOK_URL,
    FOOTER_CODEX_LINK,
    FOOTER_CONTACT,
    FOOTER_DSA,
    FOOTER_HELP_LINK,
    INSTAGRAM_MK_LINK,
    RULES_BAZAAR,
    RULES_COMMON,
    STROLLER_STROLLEROPEDIA,
} from 'mk/autogenerated/translations/Footer.5700874da4a028bf48998c89be203e5e'
import assetUrl from 'mk/common/assetUrl';
import {
    aboutContactUrl,
    aboutCookiePolicyUrl,
    aboutDSAUrl,
    aboutPrivacyPolicyUrl,
    aboutRulesCodexUrl,
    aboutRulesCommonUrl,
    aboutRulesMarketUrl,
} from 'mk2/apps/about/urls';
import { faqRootUrl } from 'mk2/apps/faq/urls';
import { strollersUrl } from 'mk2/apps/strollers/urls';
import { Img } from 'mk2/components/Img';
import { Link } from 'mk2/components/Link';
import InstallPrompt from 'mk2/containers/InstallPrompt/InstallPrompt';
import React from 'react';
import styles from './Footer.mscss';

interface OwnProps {
}

export class Footer extends React.PureComponent<OwnProps> {

    public render() {
        return (
            <div
                className={cx(
                    styles.Footer,
                    styles.Footer__hideOnMobile,
                )}
            >
                <div className={styles.Footer__help}>
                    <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <FontAwesomeIcon icon={faLifeRing} className={styles.Footer__lifering} />&nbsp;
                                <Link to={faqRootUrl} data-google-interstitial="false">{FOOTER_HELP_LINK}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesCodexUrl} data-google-interstitial="false">{FOOTER_CODEX_LINK}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesMarketUrl} data-google-interstitial="false">{RULES_BAZAAR}</Link>
                            </li>
                            <li>
                                <Link to={aboutRulesCommonUrl} data-google-interstitial="false">{RULES_COMMON}</Link>
                            </li>
                            <li>
                                <Link to={aboutContactUrl} data-google-interstitial="false">{FOOTER_CONTACT}</Link>
                            </li>
                            <li>
                                <Link to={aboutDSAUrl} data-google-interstitial="false">{FOOTER_DSA}</Link>
                            </li>
                        </ul>
                    </div>
                </div>

                <div className={styles.Footer__footer}>
                    <div className={styles.Footer__links}>
                        <ul className={styles.Footer__links_row}>
                            <li>
                                <a data-google-interstitial="false" href={COMMERCIAL_URL} target="_blank" rel="noopener">{COMMERCIAL}</a>
                            </li>
                            <li>
                                <a data-google-interstitial="false" href={CAREER_URL} target="_blank" rel="noopener">{CAREER}</a>
                            </li>
                            <li>
                                <Link to={aboutCookiePolicyUrl} data-google-interstitial="false">{COOKIE_POLICY_PAGE}</Link>
                            </li>
                            <li>
                                <Link to={aboutPrivacyPolicyUrl} data-google-interstitial="false">{DATA_PRIVACY}</Link>
                            </li>
                        </ul>
                    </div>

                    <div className={styles.Footer__apps}>
                        <a
                            data-google-interstitial="false"
                            className={styles.Footer__apps__app}
                            href="https://www.youtube.com/c/Modrykonik"
                            aria-label="Follow us on YouTube"
                        >
                            <Img width={58} height={40} src={`${assetUrl}img/3rd-party/big-youtube.png`} alt="icon" />
                        </a>
                        <a
                            data-google-interstitial="false"
                            className={styles.Footer__apps__app}
                            href={FOLLOW_US_ON_FACEBOOK_URL}
                            aria-label="Follow us on Facebook"
                        >
                            <Img width={40} height={40} src={`${assetUrl}img/3rd-party/big-facebook.png`} alt="icon" />
                        </a>
                        <a
                            data-google-interstitial="false"
                            className={cx(styles.Footer__apps__app, styles.Footer__apps__bull)}
                            href={INSTAGRAM_MK_LINK}
                            aria-label="Follow us on Instagram"
                        >
                            <Img width={40} height={40} src={`${assetUrl}img/3rd-party/big-instagram.png`} alt="icon" />
                        </a>
                        <InstallPrompt className={styles.Footer__apps__app} />
                    </div>
                </div>
            </div>
        );
    }
}

interface FooterNarrowOwnProps {
    isMobile: boolean;
    onItemClick();
}
export class FooterNarrow extends React.PureComponent<FooterNarrowOwnProps> {

    public render() {
        const {
            isMobile, onItemClick,
        } = this.props;

        return (
            <div>
                {isMobile && (
                    <InstallPrompt />
                )}
                <div className={styles.FooterNarrow__mobileFooter}>
                    <ul className={cx(styles.FooterNarrow__menuItemBlock, styles['FooterNarrow__menuItemBlock--footer'])}>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={faqRootUrl}
                                data-google-interstitial="false"
                            >
                                {isMobile && (
                                    <FontAwesomeIcon
                                        icon={faLifeRing}
                                        className={styles['FooterNarrow__mobileFooter__helpIcon--mobile']}
                                    />
                                )}
                                {FOOTER_HELP_LINK}
                                {!isMobile && (
                                    <FontAwesomeIcon
                                        icon={faLifeRing}
                                        className={styles['FooterNarrow__mobileFooter__helpIcon--desktop']}
                                    />
                                )}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutRulesCodexUrl}
                                data-google-interstitial="false"
                            >
                                {FOOTER_CODEX_LINK}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutRulesMarketUrl}
                                data-google-interstitial="false"
                            >
                                {RULES_BAZAAR}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutRulesCommonUrl}
                                data-google-interstitial="false"
                            >
                                {RULES_COMMON}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <a
                                data-google-interstitial="false"
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                href={COMMERCIAL_URL}
                                rel="noopener"
                                target="_blank"
                            >
                                {COMMERCIAL}
                            </a>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <a
                                data-google-interstitial="false"
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                href={CAREER_URL}
                                rel="noopener"
                                target="_blank"
                            >
                                {CAREER}
                            </a>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutContactUrl}
                                data-google-interstitial="false"
                            >
                                {FOOTER_CONTACT}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutCookiePolicyUrl}
                                data-google-interstitial="false"
                            >
                                {COOKIE_POLICY_PAGE}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutPrivacyPolicyUrl}
                                data-google-interstitial="false"
                            >
                                {DATA_PRIVACY}
                            </Link>
                        </li>
                        <li onClick={onItemClick} className={styles['FooterNarrow__mobileFooter--item']}>
                            <Link
                                className={cx(styles['FooterNarrow__mobileFooter--link'], 'topmenu-mobilefooterLink')}
                                to={aboutDSAUrl}
                                data-google-interstitial="false"
                            >
                                {FOOTER_DSA}
                            </Link>
                        </li>
                    </ul>

                    <div className={styles.FooterNarrow__mobileFooter__apps}>
                        <a
                            data-google-interstitial="false"
                            className={styles.FooterNarrow__mobileFooter__apps__app}
                            href="https://www.youtube.com/c/Modrykonik"
                            target="_blank"
                        >
                            <Img width={52} height={36} src={`${assetUrl}img/3rd-party/big-youtube.png`} />
                        </a>
                        <a
                            data-google-interstitial="false"
                            className={styles.FooterNarrow__mobileFooter__apps__app}
                            href={FOLLOW_US_ON_FACEBOOK_URL}
                            target="_blank"
                        >
                            <Img width={36} height={36} src={`${assetUrl}img/3rd-party/big-facebook.png`} />
                        </a>
                        <a
                            data-google-interstitial="false"
                            className={styles.FooterNarrow__mobileFooter__apps__app}
                            href={INSTAGRAM_MK_LINK}
                            target="_blank"
                        >
                            <Img width={36} height={36} src={`${assetUrl}img/3rd-party/big-instagram.png`} />
                        </a>
                        {!isMobile && (
                            <InstallPrompt
                                className={styles.FooterNarrow__mobileFooter__apps__app}
                            />
                        )}
                    </div>
                    <div className={styles.FooterNarrow__mobileFooter__apps}>
                        <FontAwesomeIcon
                            className={styles.FooterNarrow__mobileFooter__apps__cc}
                            icon={faCcVisa}
                            size="2x"
                        />
                        <FontAwesomeIcon
                            className={styles.FooterNarrow__mobileFooter__apps__cc}
                            icon={faCcMastercard}
                            size="2x"
                        />
                    </div>
                </div>
            </div>
        );
    }
}
